@use '@/scss/underscore' as _;

.samlMetadataForm {
  > div:not(:first-child) {
    margin-top: _.unit(6);
  }
}
